// extracted by mini-css-extract-plugin
module.exports = {"formSearch":"styles_formSearch__2N1yo","container":"styles_container__11N-0"};